{
  "page_count": "/ {n, plural, one{# lk} other{# lk}}"
}
